// Frontend-only field labels and tooltips
export const fieldLabels = {
  // Loan Summary Fields
  id: 'Loan ID',
  name: 'Loan Name',
  productName: 'Loan Type',
  status: 'Status',
  maturityDate: 'Maturity Date',
  numberOfInstallments: 'Tenure',
  accountName: 'Account Name',
  loanAmount: 'Loan Amount',
  nextInstallmentDate: 'Due on',
  amountDueTillCurrent: 'Next Payment',
  payOffAmountAsOfToday: 'Pay Off Amount As Of Today',
  interestRate: 'Interest Rate',
  availableAmountForNextFunding: 'Available amount for next funding',
  disbursedAmount: 'Utilized Amount',
  creditLimit: 'Credit Limit',
  disbursalAmount: 'Disbursal Amount',
  frequencyOfLoanPayment: 'Billing Frequency',
  principalRemaining: 'Principal Remaining',
  interestRemaining: 'Interest Remaining',
  feesRemaining: 'Additional Interest',
  amountToCurrent: 'Total Outstanding Due Amount',
  totalOutstandingAsOfDate: 'Total Outstanding (As of Date)',
  nextPayment:'Next Payment',

  // Payoff Quote Fields
  transactionDate: 'Payoff Date',
  principalBalance: 'Principal',
  accruedInterest: 'Interest',
  totalPayoffAmount: 'Total Payoff Amount',
  otherFees: 'Fees / Charges',
  prepaymentPenalty: 'Prepayment Fees',
  exitFees: 'Exit Fees',

  // Loan Schedule Fields
  dueDate: 'Due Date',
  dueAmount: 'Due Amount',
  duePrincipal: 'Due Principal',
  dueInterest: 'Due Interest',
  balance: 'Balance'
};

export const fieldTooltips = {
  // Landing Page & Summary Tab
  loanAmount: 'Original Loan Amount',
  productName: 'Product Type of the Loan',
  amountDueTillCurrent: 'Next Payment Amount as per the Contract',
  nextInstallmentDate: 'Date of the next Due',
  numberOfInstallments: 'Total Loan duration',
  availableAmountForNextFunding: 'Funds remaining to borrow',
  disbursedAmount: 'Funds utilized till date',

  // Summary Tab
  maturityDate: 'Loan End date',
  frequencyOfLoanPayment: 'Frequency of Bill generation',
  interestRate: 'Rate of Interest for the Loan',
  principalRemaining: 'Unpaid Loan Principal',
  interestRemaining: 'Unpaid interest till last accrual',
  feesRemaining: 'Additional Charges/Fees/Interest.',
  amountToCurrent: 'Sum of all unpaid Bills',
  totalOutstandingAsOfDate: 'Total unpaid Balance',

  // Payoff Estimator
  transactionDate: 'Date of the estimated Payoff',
  accruedInterest: 'Interest part of Payoff Amount',
  totalPayoffAmount: 'Estimated Amount to close the loan.',
  otherFees: 'Other unpaid Fees/charges.',
  prepaymentPenalty: 'Penalty for early closure',
  exitFees: 'Exit fees for loan closure.',
  principalBalance: 'Remaining unpaid Principal',
}; 
